export default __webpack_public_path__ + "static/media/gris.9a9cee86.png";